import { useEffect, useMemo } from 'react';
import { AzimutForYouState } from '../../store/features/azimut-for-you/azimut-for-you-types';
import { useAppDispatch, useAppSelector } from '../redux';
import {
  azimutForYouActions,
  downloadVideos,
} from '../../store/features/azimut-for-you';
import { VideoMediaResponse } from '../../api/generated';
import { useIntl } from 'react-intl';
import { GlobalActions } from '../../model';
import { commonErrorMessages } from '../../messages';

export interface VideoPageLogic {
  videos?: VideoMediaResponse;
  isLoadingVideos: boolean;
}

export const useVideoPageLogic = (actions: GlobalActions): VideoPageLogic => {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();
  const { showToast, closeToast } = actions;

  const token: string = useAppSelector((state) => state.data?.user?.token);

  const {
    videos: videosList,
    videosRequestStatus,
    videosError,
  } = useAppSelector(
    (state) => state.features.azimutForYou as AzimutForYouState
  );

  const foregroundVideos = useMemo(
    () => (videosList?.featured?.length > 0 ? videosList.featured : []),
    [videosList]
  );
  const otherVideos = useMemo(
    () => (videosList?.others?.length > 0 ? videosList.others : []),
    [videosList]
  );

  useEffect(() => {
    if (token) {
      dispatch(downloadVideos());
    }
  }, [dispatch, token]);

  useEffect(() => {
    if (videosError) {
      showToast({
        close: closeToast,
        title: formatMessage(commonErrorMessages.errorTitleDefault),
        description: formatMessage(commonErrorMessages.errorDescriptionDefault),
        type: 'error',
      });
      dispatch(azimutForYouActions.clearError());
    }
  }, [videosError, showToast, formatMessage, closeToast, dispatch]);

  return {
    isLoadingVideos: videosRequestStatus === 'loading',
    videos: {
      featured: foregroundVideos,
      others: otherVideos,
    },
  };
};
